<template>
  <div class="materials-page">
    <h2 class="section-title">CNC Machining Materials</h2>

    <div class="tags-container">
      <button v-for="(mat, index) in materials" :key="index" class="tag-btn" :class="{ active: currentIndex === index }"
        @click="switchMaterial(index)">
        {{ mat.name }}
      </button>
    </div>

    <div class="material-content">
      <div class="text-side">
        <h3 class="material-name">{{ materials[currentIndex].name }}</h3>
        <p class="material-desc">{{ materials[currentIndex].desc }}</p>

        <div class="detail-item" v-if="materials[currentIndex].Price">
          <span class="detail-label">Price:</span>
          <span class="detail-value">{{ materials[currentIndex].Price }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].leadTime">
          <span class="detail-label">Lead Time:</span>
          <span class="detail-value">{{ materials[currentIndex].leadTime }}</span>
        </div>

        <div class="detail-item" v-if="materials[currentIndex].WallThickness">
          <span class="detail-label">Wall Thickness:</span>
          <span class="detail-value">{{ materials[currentIndex].WallThickness }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].Tolerances">
          <span class="detail-label">Tolerances:</span>
          <span class="detail-value">{{ materials[currentIndex].Tolerances }}</span>
        </div>
        <div class="detail-item" v-if="materials[currentIndex].Maxpartsize">
          <span class="detail-label">Max part size:</span>
          <span class="detail-value">{{ materials[currentIndex].Maxpartsize }}</span>
        </div>

      </div>

      <div class="image-side">
        <img :src="materials[currentIndex].img" alt="Material sample" />
      </div>
    </div>

    <p class="footer-note">
      *For materials not shown here,
      <span class="contact-link" @click="$router.push('/contact')">please contact us directly.</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Materials',
  data() {
    return {
      currentIndex: 0,
      materials: [
        {
          name: 'Aluminum',
          desc: 'Aluminum is a highly ductile metal, making it easy to machine. The material has a good strength-to-weight ratio and is available in many types for a range of applications.',
          Price: '$',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
          leadTime: '< 10 days',
          img: require('@/assets/product/CNC_Materials/1.jpg')
        },
        {
          name: 'Copper',
          desc: 'Copper displays excellent thermal conductivity, electrical conductivity and plasticity. It is also highly ductile, corrosion resistant and can be easily welded.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
           img: require('@/assets/product/CNC_Materials/3.png')

        },
        {
          name: 'Brass',
          desc: 'Brass has desirable properties for a number of applications. It is low friction, has excellent electrical conductivity and has a golden (brass) appearance.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/2.png')

        },
        {
          name: 'Bronze',
          desc: 'Bronze has strong, superior corrosion resistance, particularly in marine environments, suitable for bearings and bushings.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
           img: require('@/assets/product/CNC_Materials/4.png')
        },
        {
          name: 'Stainless Steel',
          desc: 'Stainless steel is the low carbon steel that offers many properties that are sought after for industrial applications. Stainless steel typically contains a minimum of 10% chromium by weight.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
          img: require('@/assets/product/CNC_Materials/5.webp')
        },
         {
          name: 'Steel',
          desc: 'XCL offers a wide range of steel options to meet the demands of various applications. Alloy and carbon steel are particularly useful for creating fixtures, mounting plates, draft shafts, axles, torsion bars, gears, bolts, studs, shafts, and structural components. High-quality steel materials provide excellent strength and durability, making them ideal for demanding industrial applications.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
          img: require('@/assets/product/CNC_Materials/6.webp')

        },
        {
          name: 'Magnesium',
          desc: 'Magnesium has lightest structural metal, high strength-to-weight ratio, easily machinable, beneficial for weight-sensitive applications.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/7.webp')
        },
        {
          name: 'Molybdenum',
          desc: 'Molybdenum has high Strength and Durability, also has excellent Heat and Corrosion Resistance.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/8.webp')
        },
        {
          name: 'ABS',
          desc: 'ABS has excellent overall physical and mechanical properties, excellent low temperature impact resistance. Dimensional stability. Electrical properties, wear resistance, chemical resistance, dyeing, finished product processing and machining are better.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/9.webp')
        },
        {
          name: 'PEEK',
          desc: 'PEEK materials have superior dimensional stability properties, which are important for certain applications. Changes in temperature,humidity and other environmental conditions have little effect on the dimensions of PEEK parts and can meet the requirements for use under conditions requiring high dimensional accuracy.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/10.webp')
        },

        {
          name: 'PTFE',
          desc: 'Poly tetra fluoroethylene material (PTFE) has excellent heat and cold resistance, and can be used for a long time at -180 to 260ºC. This material has the characteristics of acid and alkali resistance, resistance to various organic solvents, almost insoluble in all solvents.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/11.webp')
        },
        {
          name: 'PC',
          desc: 'Polycarbonate materials are heat-resistant, impact resistant, and highly transparent. PC materials must be dried so that the moisture content is reduced to less than 0.02%, which ensures that the product has good mechanical properties in a variety of environments.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/12.jpg')
        },
        {
          name: 'PMMA',
          desc: 'PMMA materials is known for its clarity, this plastic is often used as a glass substitute for windows, lenses, and displays.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
      img: require('@/assets/product/CNC_Materials/13.webp')
        },
        {
          name: 'HDPE',
          desc: 'HPDE materials is low-cost, chemical-resistant, and durable, often used in tanks, pipes, and industrial components.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/14.webp')
        },
        {
          name: 'POM(Delrin)',
          desc: 'The mechanical properties of POM materials are close to those of metal materials, and its creep resistance and fatigue resistance are excellent, and it also has the characteristics of self-lubrication, which is very suitable for use as engineering components.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/15.webp')
        },

        {
          name: 'PA(Nylon)',
          desc: 'Nylon is the first man-made synthetic fiber that appeared in the world. It is strong and wear-resistant, low density, light in size, good in elasticity, good in chemical stability, large in output and widely used.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/16.webp')
        },

        {
          name: 'Polyethylene',
          desc: 'Polyethylene material has excellent low temperature resistance (the lowest use temperature can reach -100~-70°C) and good chemical stability. It is insoluble in general solvents at room temperature, with small water absorption and excellent electrical insulation.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/17.webp')
        },
        {
          name: 'Garolite G-10',
          desc: 'Garolite G-10 is a glass fiber and resin laminated composite material, originally developed as an aerospace equipment material, can withstand great force without damage deformation . It is characterized by insulation, corrosion resistance and abrasion resistance.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
          img: require('@/assets/product/CNC_Materials/18.webp')
        },

        
          {
          name: 'Acrylic',
          desc: 'Acrylic is a durable plastic material that is resistant to scratches, making it an ideal choice for various applications such as tanks, panels, and optical displays. It is also lightweight and shatter-resistant, which makes it a popular alternative to glass. Acrylic is known for its clarity and transparency, making it a great option for applications where optical performance is important. Additionally, it can be easily fabricated into different shapes and sizes, allowing for a wide range of design possibilities.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/20.png')
        },
         {
          name: 'Cast Iron',
          desc: 'Cast Iron is a material known for its durability and wear resistance, making it an excellent choice for absorbing vibrations. It is commonly used in various industrial applications such as gears, bases, pulleys, and bushings. Due to its ability to withstand high levels of stress and pressure, cast iron is often preferred over other materials in heavy-duty machinery and equipment. Its unique properties make it a reliable option for industries that require stable and long-lasting components.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/21.png')
        },

          {
          name: 'Invar',
          desc: 'Invar is a Ni-Fe alloy with high dimensional accuracy and excellent thermal dimensional stability. It is commonly used in industries such as aerospace, electronics, and precision engineering. Common applications include precision instruments and devices where temperature-dimensional changes are undesirable. It is ideal for components such as clock pendulums, bi-metallic strips, and measuring instruments. In the aerospace industry, Invar is used in satellite structures, antennas, and optical systems.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
        img: require('@/assets/product/CNC_Materials/23.webp')
        },
          {
          name: 'Kovar',
          desc: 'Kovar is a Ni-Fe-Co alloy known for its excellent thermal expansion properties and dimensional stability. It is commonly used for electronics, telecommunications, and aerospace components, such as hermetic seals for devices like vacuum tubes and transistors, telecommunications equipment, and turbine blades. Its ability to nearly match the coefficient of thermal expansion of glass enables airtight sealing, preventing moisture or contaminants from damaging sensitive electronic components.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/24.webp')
        },
        
         {
          name: 'PPS',
          desc: 'Polyphenylene Sulfide (PPS) is a thermoplastic with exceptional chemical resistance, thermal stability, high-temperature resistance, chemical resistance, dimensional stability, and electrical insulation. Common applications include automotive components, electrical connectors, and industrial equipment, such as fuel systems, turbine blades, brake pads, bearings, gears, switches, and engine components. PPS parts remain durable and reliable even in harsh environments.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/26.png')
        },
          {
          name: 'PVC',
          desc: 'PVC (Polyvinyl chloride) is a plastic with high durability and versatility, excellent chemical and UV and corrosion resistance. Common applications include pipes, fittings, electrical enclosures, tubing, automotive interior, and commercial building components. It is cost-effective and lightweight, with a long lifespan.',
          Price: '$',
          leadTime: '< 10 days',
          WallThickness: '0.75 mm',
          Tolerances: "±0.01mm",
          Maxpartsize: '200 x 80 x 100 cm',
         img: require('@/assets/product/CNC_Materials/27.png')
        }
      ]
    }
  },
  methods: {
    switchMaterial(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.materials-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.section-title {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 30px;
}

.tag-btn {
  padding: 5px 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #646363;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-weight: 600;

  &.active {
    background-color: #16bc9c;
    border-color: #16bc9c;
    color: #fff;
  }

  &:hover:not(.active) {
    border-color: #16bc9c;
    color: #16bc9c;
  }
}

.material-content {
  display: flex;
  border: 1px solid #e5e5e5;
  margin-bottom: 30px;

  .text-side {
    flex: 1;
    padding: 30px;
    border-right: 1px solid #e5e5e5;

    .material-name {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 16px;
    }

    .material-desc {
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .detail-item {
      margin-bottom: 12px;
      color: #666;

      .detail-label {
        font-weight: 600;
        color: #333;
        margin-right: 4px;
      }
    }
  }

  .image-side {
    flex: 1.6;
    background-color: #f9f9f9;
    display: flex;
    justify-content: center; 
    align-items: center;     
    img {
      width: 70%;
      object-fit: contain; 
    }
  }
}

.footer-note {
  text-align: left;
  color: #666;
  font-size: 16px;
  font-weight: 400;

  .contact-link {
    color: #16bc9c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 🔥 移动端响应式样式更新 */
@media (max-width: 768px) {
  .material-content {
    flex-direction: column;
    /* 1. 去除整体外边框 */
    border: none; 

    /* 2. 利用 order 改变显示顺序：让 image-side 显示在 text-side 前面 */
    .image-side {
      order: 1;
      padding: 20px 0;
      background-color: #f9f9f9; /* 保留一点底色区分图片，如果不需要可以改为 transparent */
      border-radius: 8px; /* 给图片容器加个圆角好看点 */
      margin-bottom: 20px; /* 和下方文字隔开一点 */
      
      img {
        width: 80%; /* 移动端图片稍微放大一点点 */
      }
    }

    .text-side {
      order: 2;
      /* 3. 去除内部原有的右、下边框 */
      border-right: none;
      border-bottom: none;
      /* 4. 移动端取消大内边距，让文字紧凑排版 */
      padding: 0; 
    }
  }
}
</style>